/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EquipmentTypeEnum } from './EquipmentTypeEnum';
import {
    EquipmentTypeEnumFromJSON,
    EquipmentTypeEnumFromJSONTyped,
    EquipmentTypeEnumToJSON,
    EquipmentTypeEnumToJSONTyped,
} from './EquipmentTypeEnum';
import type { DataPointMapLocation } from './DataPointMapLocation';
import {
    DataPointMapLocationFromJSON,
    DataPointMapLocationFromJSONTyped,
    DataPointMapLocationToJSON,
    DataPointMapLocationToJSONTyped,
} from './DataPointMapLocation';
import type { EquipmentGeometry } from './EquipmentGeometry';
import {
    EquipmentGeometryFromJSON,
    EquipmentGeometryFromJSONTyped,
    EquipmentGeometryToJSON,
    EquipmentGeometryToJSONTyped,
} from './EquipmentGeometry';

/**
 * Equipment serializer.
 * @export
 * @interface Equipment
 */
export interface Equipment {
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    readonly id: string;
    /**
     * 
     * @type {number}
     * @memberof Equipment
     */
    owner?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    site?: string | null;
    /**
     * Retrieves all active flags for current user.
     * @type {string}
     * @memberof Equipment
     */
    readonly siteName: string;
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    pipeline?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    parent?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof Equipment
     */
    children: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    groupName?: string;
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    material?: string;
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    fuel?: string;
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    equipmentClass?: string;
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    equipmentSubClass?: string;
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    manufacturerMake?: string;
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    manufacturerModel?: string;
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    manufacturerSerialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    operatorStatus?: string;
    /**
     * 
     * @type {Date}
     * @memberof Equipment
     */
    dateOfInstallation?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Equipment
     */
    dateOfLastModification?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    operatorUniqueId?: string;
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    otherOperatorIds?: string;
    /**
     * 
     * @type {EquipmentTypeEnum}
     * @memberof Equipment
     */
    equipmentType: EquipmentTypeEnum;
    /**
     * 
     * @type {DataPointMapLocation}
     * @memberof Equipment
     */
    location: DataPointMapLocation;
    /**
     * 
     * @type {EquipmentGeometry}
     * @memberof Equipment
     */
    geometry: EquipmentGeometry;
    /**
     * 
     * @type {Date}
     * @memberof Equipment
     */
    startDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Equipment
     */
    endDate?: Date | null;
    /**
     * 
     * @type {any}
     * @memberof Equipment
     */
    extraData?: any | null;
}



/**
 * Check if a given object implements the Equipment interface.
 */
export function instanceOfEquipment(value: object): value is Equipment {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('siteName' in (value as Record<string, any>)) && !('site_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['siteName'] === undefined && (value as Record<string, any>)['site_name'] === undefined)) return false;
    if (!('children' in value) || value['children'] === undefined) return false;
    if ((!('equipmentType' in (value as Record<string, any>)) && !('equipment_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['equipmentType'] === undefined && (value as Record<string, any>)['equipment_type'] === undefined)) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if (!('geometry' in value) || value['geometry'] === undefined) return false;
    return true;
}

export function EquipmentFromJSON(json: any): Equipment {
    return EquipmentFromJSONTyped(json, false);
}

export function EquipmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Equipment {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'owner': json['owner'] === undefined ? undefined : json['owner'] === null ? null : json['owner'],
        'site': json['site'] === undefined ? undefined : json['site'] === null ? null : json['site'],
        'siteName': json['site_name'],
        'pipeline': json['pipeline'] === undefined ? undefined : json['pipeline'] === null ? null : json['pipeline'],
        'parent': json['parent'] === undefined ? undefined : json['parent'] === null ? null : json['parent'],
        'children': json['children'],
        'groupName': json['group_name'] == null ? undefined : json['group_name'],
        'material': json['material'] == null ? undefined : json['material'],
        'fuel': json['fuel'] == null ? undefined : json['fuel'],
        'equipmentClass': json['equipment_class'] == null ? undefined : json['equipment_class'],
        'equipmentSubClass': json['equipment_sub_class'] == null ? undefined : json['equipment_sub_class'],
        'manufacturerMake': json['manufacturer_make'] == null ? undefined : json['manufacturer_make'],
        'manufacturerModel': json['manufacturer_model'] == null ? undefined : json['manufacturer_model'],
        'manufacturerSerialNumber': json['manufacturer_serial_number'] == null ? undefined : json['manufacturer_serial_number'],
        'operatorStatus': json['operator_status'] == null ? undefined : json['operator_status'],
        'dateOfInstallation': json['date_of_installation'] === undefined ? undefined : json['date_of_installation'] === null ? null : (new Date(json['date_of_installation'])),
        'dateOfLastModification': json['date_of_last_modification'] === undefined ? undefined : json['date_of_last_modification'] === null ? null : (new Date(json['date_of_last_modification'])),
        'operatorUniqueId': json['operator_unique_id'] == null ? undefined : json['operator_unique_id'],
        'otherOperatorIds': json['other_operator_ids'] == null ? undefined : json['other_operator_ids'],
        'equipmentType': EquipmentTypeEnumFromJSON(json['equipment_type']),
        'location': DataPointMapLocationFromJSON(json['location']),
        'geometry': EquipmentGeometryFromJSON(json['geometry']),
        'startDate': json['start_date'] === undefined ? undefined : json['start_date'] === null ? null : (new Date(json['start_date'])),
        'endDate': json['end_date'] === undefined ? undefined : json['end_date'] === null ? null : (new Date(json['end_date'])),
        'extraData': json['extra_data'] === undefined ? undefined : json['extra_data'] === null ? null : json['extra_data'],
    };
}

export function EquipmentToJSON(json: any): Equipment {
    return EquipmentToJSONTyped(json, false);
}

export function EquipmentToJSONTyped(value?: Omit<Equipment, 'id'|'siteName'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'owner': value['owner'],
        'site': value['site'],
        'pipeline': value['pipeline'],
        'parent': value['parent'],
        'children': value['children'],
        'group_name': value['groupName'],
        'material': value['material'],
        'fuel': value['fuel'],
        'equipment_class': value['equipmentClass'],
        'equipment_sub_class': value['equipmentSubClass'],
        'manufacturer_make': value['manufacturerMake'],
        'manufacturer_model': value['manufacturerModel'],
        'manufacturer_serial_number': value['manufacturerSerialNumber'],
        'operator_status': value['operatorStatus'],
        'date_of_installation': value['dateOfInstallation'] == null ? value['dateOfInstallation'] : value['dateOfInstallation'].toISOString().substring(0,10),
        'date_of_last_modification': value['dateOfLastModification'] == null ? value['dateOfLastModification'] : value['dateOfLastModification'].toISOString().substring(0,10),
        'operator_unique_id': value['operatorUniqueId'],
        'other_operator_ids': value['otherOperatorIds'],
        'equipment_type': EquipmentTypeEnumToJSON(value['equipmentType']),
        'location': DataPointMapLocationToJSON(value['location']),
        'geometry': EquipmentGeometryToJSON(value['geometry']),
        'start_date': value['startDate'] == null ? value['startDate'] : value['startDate'].toISOString().substring(0,10),
        'end_date': value['endDate'] == null ? value['endDate'] : value['endDate'].toISOString().substring(0,10),
        'extra_data': value['extraData'],
    };
}

